import { Text, Box, VStack, Center, Heading, Stack, FormControl,FormLabel,Input,Checkbox,Button } from '@chakra-ui/react'
import Footer from '../components/Footer'
import { useTranslation } from 'react-i18next'

const LoginPage = () => {
    const { t } = useTranslation()

  return (
    <>

        <Box
            bgGradient={'linear(to-tr, pink.100, orange.200)'}
            width={'100%'}
            position="relative"
            padding={'12vh 0vw'}
             >
                <VStack
                    width={'fit-content'}
                    margin={'auto'}
                  >
                        <Stack align={'center'}
                            maxW={'90vw'}>
                            <Heading fontSize={'2xl'} textAlign={'center'}>{t('auth.title')}</Heading>
                            <Text fontSize={'lg'} color={'gray.600'} textAlign={'center'}>
                                {t('auth.intro')}
                            </Text>
                            <Text fontSize={'sm'} color={'gray.600'}>
                                {t('auth.note')}
                            </Text>
                        </Stack>
                        <Center
                          bg={'rgba(255,255,255,0.5)'}
                          borderRadius={'10'}
                          w={'100%'}
                          minH={{base:'20vh', md:'50vh'}}
                          padding={'6vh 2vw'}>
                            <Center>
                                <Stack spacing={4}>
                                    <FormControl id="email">
                                    <FormLabel>{t('auth.email')}</FormLabel>
                                    <Input type="email" />
                                    </FormControl>
                                    <FormControl id="password">
                                    <FormLabel>{t('auth.password')}</FormLabel>
                                    <Input type="password" />
                                    </FormControl>
                                    <Stack spacing={10}>
                                    <Stack
                                        direction={{ base: 'column', sm: 'row' }}
                                        align={'start'}
                                        justify={'space-between'}>
                                    <Checkbox>{t('auth.remember')}</Checkbox>
                                        <Text color={'gray.600'}>{t('auth.forgot')}</Text>
                                    </Stack>
                                    <Button
                                        bg={'gray.400'}
                                        color={'white'}
                                        disabled={true}
                                        _hover={{
                                        bg: 'gray.500',
                                        }}>
                                        {t('auth.unavailable')}
                                    </Button>
                                    </Stack>
                                </Stack>
                            </Center>
                        </Center>

                </VStack>

        </Box>
        <Footer></Footer>

    </>
  )
}

export default LoginPage
